document.getElementById('my-account-button-register').addEventListener('click', (e) => {
  e.target.classList.add('active');
  document.getElementById('my-account-button-login').classList.remove('active');
  document.getElementById('my-account-login').classList.remove('visible');
  document.getElementById('my-account-login').classList.add('hidden');
  document.getElementById('my-account-register').classList.remove('hidden');
  document.getElementById('my-account-register').classList.add('visible');
});

document.getElementById('my-account-button-login').addEventListener('click', (e) => {
  e.target.classList.add('active');
  document.getElementById('my-account-button-register').classList.remove('active');
  document.getElementById('my-account-register').classList.remove('visible');
  document.getElementById('my-account-register').classList.add('hidden');
  document.getElementById('my-account-login').classList.remove('hidden');
  document.getElementById('my-account-login').classList.add('visible');
});

// Password eye
const pwdInput = document.getElementById('acf-field_60095163bd67c');
const pwdRepeatInput = document.getElementById('acf-field_6009c2ef79863');

pwdInput.parentNode.classList.add('input-group');
pwdRepeatInput.parentNode.classList.add('input-group');

const inputGroupBtn = document.createElement('div');
inputGroupBtn.classList.add('input-group-append');
inputGroupBtn.innerHTML = '<span class="input-group-text"><i class="pwd-eye"></i></span>';

pwdInput.insertAdjacentHTML('afterEnd', inputGroupBtn.outerHTML);
pwdRepeatInput.insertAdjacentHTML('afterEnd', inputGroupBtn.outerHTML);

document.addEventListener('click', (event) => {
  if (event.target.matches('.pwd-eye')) {
    event.preventDefault();
    const input = event.target.parentNode.parentNode.parentNode.querySelector('input');
    if (input.type === 'password') {
      input.type = 'text';
    } else {
      input.type = 'password';
    }
  }
});
